var render = function render(){var _vm=this,_c=_vm._self._c;return _c('doughnut-chart',{attrs:{"chart-data":_vm.doughnutDataCollection,"styles":_vm.chartStyles,"options":_vm.doughnutOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }